
function truncateText(text, wordLimit) {
  if (typeof text !== 'string') return '';


  if (text.length > wordLimit) {
    return text.slice(0, wordLimit) + '...';
  }
  return text;
}
const DateFormater = (dateString) => {

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;

}
const DateTimeFormater = (date) => {
  // Ensure date is a Date object
  const d = new Date(date);

  // Get individual date and time components
  const year = d.getFullYear();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  let hours = d.getHours();
  let minutes = d.getMinutes();

  // Add leading zeros if necessary
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${day}/${month}/${year}  ${hours}:${minutes}`;
};
const UkDateFormater = (date) => {

  const d = new Date(date);
  const year = d.getFullYear();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  return `${day}/${month}/${year}`;

};

const getStatus = (status, isPgd) => {
  switch (status) {
    case "NOT_STARTED":
      return { text: "ERROR", class: "alert-danger" }; // RED
    case "ASSESSMENT_REQUIRED":
      return { text: "ASSESSMENT INCOMPLETE", class: "alert-info" }; // GREY
    case "PENDING":
      return { text: "PENDING P APPROVAL", class: "alert-warning" }; // ORANGE
    case "SEND_TO_RM":
      return { text: "READY FOR RM", class: "alert-custom" }; // RED
    case "PROCESSED":
      return { text: "SENT TO RM", class: "alert-primary" }; // BLUE
    case "SHIPPED":
      return { text: "DISPATCHED", class: "alert-success" }; // GREEN
    case "PRIME_READY":
      return { text: "PRIME READY", class: "alert-custom" }; // GREY
    case "PENDING_REVIEW":
      return { text: "PENDING REVIEW", class: "alert-warning" }; // ORANGE
    default:
      return { text: status, class: "alert-secondary" }; // Default case
  }
};

    // const getStatus = (status, isPgd) => {
    //     const status = order.status;
    //     const isPgd = order.isPgd;
    //     switch (status) {
    //       case "NOT_STARTED":
    //         return { text: "ERROR", class: "alert-danger" }; // RED
    //       case "PROCESSED":
    //         return { text: "SENT TO RM", class: "alert-primary" }; // BLUE
    //       case "ASSESSMENT_REQUIRED":
    //         return { text: "ASSESSMENT INCOMPLETE", class: "alert-secondary" }; // GREY
    //       case "PENDING":
    //         return { text: "PENDING P APPROVAL", class: "alert-warning" }; // ORANGE
    //         case "PRIME_READY" && isPgd:
    //             if (isPgd) {
    //         return { text: "PENDING P APPROVAL", class: "alert-warning" };
    //                 }
    //                 break;
    //       case "SHIPPED":
    //         return { text: "DISPATCHED", class: "alert-success" }; // GREEN
    //       default:
    //         return { text: status, class: "alert-secondary" }; // Default case
    //     }
    // };



const getCarrierFromField = (carrier) => {
  const carrierField = carrier ? carrier.toLowerCase() : '';
  if (carrierField.includes('amz') || carrierField.includes('amazon')) return 'AMAZON';
  if (carrierField.includes('royal') || carrierField.includes('rm')) return 'RM';
  return null;
};

const determineCarrier = (trackingNumber, orderData = {}) => {
  if (!trackingNumber) return 'UNKNOWN';
  const tn = trackingNumber.trim();
  const postageField = orderData.postage ? orderData.postage.toLowerCase() : '';

  // Priority 1: Check Carrier Field (if exists) + Basic Verification
  const carrierFromField = getCarrierFromField(orderData.carrier);
  if (carrierFromField) return carrierFromField;

  // Priority 2: "UK" Prefix Rule (Strong indicator for Amazon Logistics UK)
  if (tn.startsWith('UK') && tn.length > 10) {
    return 'AMAZON';
  }

  // Priority 3: Fallback Checks (Postage & Regex)
  if (postageField.includes('amazon') || tn.startsWith('TBA')) {
    return 'AMAZON';
  }

  // Strict Regex Checks
  const rmRegex = /^[A-Z]{2}[0-9]{9}GB$/; // e.g. XY123456789GB
  const amzDigitRegex = /^\d{12}$|^\d{10}$/; // e.g. 12 or 10 digits

  if (rmRegex.test(tn)) return 'RM';
  if (amzDigitRegex.test(tn)) return 'AMAZON';

  return 'RM';
};

const CARRIER_LABELS = { AMAZON: 'Amazon Shipping', RM: 'Royal Mail' };

const getCarrierLabel = (order) => {
  const carrier = getCarrierFromField(order?.carrier)
    || (order?.trackingNumber ? determineCarrier(order.trackingNumber, order) : null);
  return CARRIER_LABELS[carrier] || order?.carrier || null;
};

// Amazon dispatch writes `shippedDate`, while the Royal Mail feed writes the actual
// dispatch timestamp to `shippingDate` for eBay/RM orders — so fall back to it.
const getShippedDate = (order) => order?.shippedDate || order?.shippingDate || null;

// Working days to delivery per postage code
const SERVICE_TRANSIT_DAYS = [
  { pattern: /^(TPN|TRN|SD|CRL24|BPL1|STL1)/i, days: 1 }, // Royal Mail Tracked 24 / Special Delivery / 1st Class
  { pattern: /^(TPS|TRS|CRL48)/i, days: 2 },              // Royal Mail Tracked 48 / 48
  { pattern: /^(BPL2|STL2)/i, days: 3 },                  // Royal Mail 2nd Class
  { pattern: /^SWA-UK-PREM/i, days: 1 },                  // Amazon Shipping Premium
  { pattern: /^SWA-UK-2D/i, days: 2 },                    // Amazon Shipping Standard
  { pattern: /^SWA-UK-ECON/i, days: 3 },                  // Amazon Shipping Economy
];

const addWorkingDays = (date, days) => {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) added += 1;
  }
  return result;
};

const getServiceEstimatedDelivery = (order) => {
  const shippedDate = getShippedDate(order);
  const service = SERVICE_TRANSIT_DAYS.find(({ pattern }) => pattern.test(order?.postageCode || ''));
  if (!shippedDate || !service) return null;
  return addWorkingDays(shippedDate, service.days);
};

const getTrackingEstimatedDelivery = (trackingData) =>
  trackingData?.mailPieces?.estimatedDelivery?.date
  || trackingData?.payload?.promisedDeliveryDate
  || null;

// Statuses where the order has not been handed to the courier yet (mirrors the backend check).
const DISPATCH_SCHEDULABLE_STATUSES = [
  "NOT_STARTED",
  "ASSESSMENT_REQUIRED",
  "PENDING",
  "PENDING_REVIEW",
  "SEND_TO_RM",
  "PRIME_READY",
];

const canScheduleDispatch = (order) => DISPATCH_SCHEDULABLE_STATUSES.includes(order?.status);

// Orders with a scheduled dispatch date after today are held back from courier runs.
const isDispatchScheduledForLater = (order) => {
  if (!order?.scheduledDispatchDate) return false;
  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);
  return new Date(order.scheduledDispatchDate) > endOfToday;
};

// Whole days between today and the scheduled dispatch date; null when none is set.
const getDaysUntilDispatch = (order) => {
  if (!order?.scheduledDispatchDate) return null;
  const dispatchOn = new Date(order.scheduledDispatchDate);
  dispatchOn.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((dispatchOn - today) / 86400000);
};

const formatDaysUntilDispatch = (order) => {
  const days = getDaysUntilDispatch(order);
  return days === 1 ? '1 day' : `${days} days`;
};

export {
  truncateText,
  DateFormater,
  DateTimeFormater,
  UkDateFormater,
  getStatus,
  determineCarrier,
  getCarrierLabel,
  getShippedDate,
  getServiceEstimatedDelivery,
  getTrackingEstimatedDelivery,
  canScheduleDispatch,
  isDispatchScheduledForLater,
  getDaysUntilDispatch,
  formatDaysUntilDispatch,
};